import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { api } from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem("nicu_user") || "null"); } catch { return null; }
  });
  const [loading, setLoading] = useState(false);

  const login = async (username, password, user_type, otp_code) => {
    const { data } = await api.post("/auth/login", { username, password, user_type, otp_code });
    localStorage.setItem("nicu_token", data.token);
    localStorage.setItem("nicu_user", JSON.stringify(data.user));
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("nicu_token");
    localStorage.removeItem("nicu_user");
    try {
      Object.keys(localStorage).filter((k) => k.startsWith("nicu_r_")).forEach((k) => localStorage.removeItem(k));
      navigator.serviceWorker?.controller?.postMessage("CLEAR_API_CACHE");
    } catch (e) { console.warn("cache clear failed", e); }
    setUser(null);
  };

  useEffect(() => {
    const t = localStorage.getItem("nicu_token");
    if (!t) return;
    setLoading(true);
    api.get("/auth/me").then(({ data }) => {
      setUser(data);
      localStorage.setItem("nicu_user", JSON.stringify(data));
    }).catch((e) => { console.warn("auth/me refresh failed", e); }).finally(() => setLoading(false));
  }, []);

  const value = useMemo(() => ({ user, loading, login, logout }), [user, loading]);

  return <AuthCtx.Provider value={value}>{children}</AuthCtx.Provider>;
}

export function useAuth() { return useContext(AuthCtx); }
